import { InputValidationError } from '@zyro-inc/site-modules/types';

type ValidationType = 'required' | 'min' | 'max';

export type NumberValidationOptions = {
	fieldName: string;
	validations: ValidationType[];
	validationMessages: Record<string, string>;
	min?: number;
	max?: number;
};

export default function validateNumber({
	value,
	options,
}: {
	value?: number,
	options: NumberValidationOptions}): InputValidationError[] {
	const validationErrors = [];

	if (options.validations.includes('required') && value === undefined) {
		validationErrors.push({
			message: options.validationMessages.required,
			name: options.fieldName,
		});

		return validationErrors;
	}

	if (options.validations.includes('min') && !!options.min && !!value && value < options.min) {
		validationErrors.push({
			message: options.validationMessages.min,
			name: options.fieldName,
		});
	}

	if (options.validations.includes('max') && !!options.max && !!value && value > options.max) {
		validationErrors.push({
			message: options.validationMessages.max,
			name: options.fieldName,
		});
	}

	return validationErrors;
}
